<template>
  <div class="privacy-policy">
    <h1>Privacy Policy</h1>
    <section>
      <h2>Last updated: February 23, 2025</h2>
      <p>
        BANFAAN and its subsidiaries that make up the BANFAAN group
        of companies (BANFAAN, we, us, or
        our) are industry-leading developers, publishers, and
        marketers of interactive entertainment. Please read this Privacy Policy
        carefully and be aware that our practices and the data we collect may
        vary depending on how you use the Services. The Services are also
        subject to any additional terms and policies included in our Services.
        This Privacy Policy is in addition to the privacy disclosures provided
        by the manufacturer of your software product and your platform.
      </p>

      <h2>Categories of Information Collected</h2>
      <br />
      <p>
        The categories of information we collect depend on how you use the
        Services. We typically collect the following information:
      </p>

      <p>
        Identifiers/Contact Information: Name, username, gamertag, mailing and
        email addresses, phone number, unique ID, mobile device ID, platform ID,
        gaming service ID, advertising IDs (IDFA (Identifier for Advertisers),
        Android ID), and IP address
      </p>

      <p>Protected Characteristics: Age and gender</p>

      <p>
        Commercial Information: Purchase and usage history and preferences,
        including gaming information
      </p>

      <p>
        **Billing Information:** Payment information (debit/credit card
        information) and shipping address
      </p>

      <p>
        Internet/Electronic Activity: Web/app browsing and gaming information
        related to the Services; information about your online interactions with
        the Services or our advertisements; details about the games and
        platforms you use, and other information about installed applications
      </p>

      <p>
        Device and Usage Data: device type, software and hardware details,
        language settings, browser type and version, operating system, and other
        information about how users use and interact with the Services Related
        information (e.g., content viewed, pages visited, clicks, scrolling)
      </p>

      <p>
        Inferred Profile Information: Information inferred from your information
        and web activity to help create a personalized profile so that we can
        determine what goods and services may be of interest to you
      </p>

      <p>
        Audio/Video Information: Account photos, images and avatars, audio
        information collected through chat features and functionality, and
        gameplay recordings and video clips (such as video clips recorded when
        you participate in a game test)
      </p>

      <p>
        Sensitive Information: Precise location information (if you allow the
        Service to collect your location), account credentials (username and
        password), and the content of communications collected through chat
        features and functionality.
      </p>

      <p>How We Use Your Information and Our Legal Basis</p>

      <p>
        We use the information we collect at BANFAAN based on various legal bases,
        as described below:
      </p>

      <p>
        Business Purposes: Providing services and support; fulfilling orders and
        requests; improving the Services and our business; developing new
        products and services; enhancing your experience with the Services;
        protecting the safety of our users, employees, facilities and services;
        conducting internal marketing and demographic research
      </p>

      <p>
        Business Purposes: Marketing and advertising our and our business
        partners’ products and services; sending you promotional materials; and
        administering promotions
      </p>

      <p>We also use your information as permitted by law.</p>

      <p>
        We use the information we collect for our business purposes, including
        to:
      </p>

      <p>Provide the Services</p>

      <p>
        Fulfill product orders and other requests, respond to your questions,
        and communicate with you
      </p>

      <p>
        Enhance and personalize your experience with the Services, including
        identifying you, maintaining your preferences and settings, connecting
        you to other users, and associating you with your third-party platform,
        game, and social network accounts
      </p>

      <p>Provide technical and other support</p>

      <p>
        Review the use and operation of the Services, develop new products or
        services, and perform analytics to enhance or improve our software,
        content, marketing, support, and services
      </p>

      <p>Perform internal marketing and demographic research</p>

      <p>Address problems with the Services or other business needs</p>

      <p>
        Protect the security or integrity of the Services, our users, and our
        business, such as to prevent violations of our terms and policies,
        including combating fraud, piracy, cheating, tampering, unauthorized
        transactions, protecting against claims and other liabilities, and
        managing risk exposure
      </p>

      <p>
        Interact on your behalf with your third-party platform, game, and social
        network accounts associated with our Services
      </p>

      <p>
        Engage in other processing, which we will notify you of at the time you
        provide your information or when you consent to such other processing
      </p>

      <p>Business Purposes Permitted by Law</p>

      <p>
        We use the information we collect for our business purposes, including
        to:
      </p>

      <p>
        On behalf of BANFAAN or our business partners to provide you and other
        users with customized content, targeted offers and advertising via email
        and text messages (or on other websites, mobile applications or social
        media)
      </p>

      <p>Send you information and promotional materials</p>

      <p>
        Run rewards, surveys, sweepstakes, contests or other promotions
        sponsored or managed by us or our business partners
      </p>

      <p>
        Analyze our users in combination with other data to evaluate our user
        base and target marketing to other similar groups
      </p>

      <p>—Legal Basis for Processing Personal Data</p>

      <p>
        If you are in a location that requires us to rely on a legal basis to
        process your information, we will process your information based on the
        following legal basis:
      </p>

      <p>
        With To enter into contracts with you and to perform such contracts
        (such as the terms that apply to our Services, or to take steps at your
        request, such as taking steps to complete a transaction with you and
        allow you to play our games online)
      </p>

      <p>Comply with legal obligations</p>

      <p>
        Our legitimate interests or those of our partners, such as to improve
        our products and services; perform analytics to gain insights about our
        users; conduct direct marketing (where we do not need your consent);
        otherwise support our business, operations, and Services; and enforce
        and prevent violations of our terms or policies
      </p>

      <p>
        To protect your vital interests or those of others (such as other
        players)
      </p>

      <p>
        With your consent, such as when you sign up for direct marketing or
        connect your BANFAAN account with a third-party service
      </p>

      <h2>From where we collect information</h2>
      <br />
      <p>
        The way we get information depends on how you use the Services. For
        example, we:
      </p>

      <p>
        Collect information you provide directly to us, such as when you create
        an account, sign up for marketing, or contact us
      </p>

      <p>(Automatically collected) Information about the games you play</p>

      <p>
        From third-party platforms, such as when you play our games or access
        our Services using a third-party account
      </p>

      <p>
        Automatically collected, including through cookies and similar tracking
        technologies
      </p>

      <p>
        From third parties, such as advertising networks, business partners,
        third-party information providers, and other players
      </p>

      <p>—Information You Provide</p>

      <p>
        You provide us information when you use the Services, such as when you:
      </p>

      <p>Create an account or use the Services</p>

      <p>Subscribe to marketing and communications</p>

      <p>
        Post comments on our message boards, forums, chat rooms, feeds,
        websites, or other services
      </p>

      <p>
        Purchase or redeem one of our products or services (including physical
        items, virtual items, virtual currency, or plugins)
      </p>

      <p>
        Download, install, or access a demo game, program, or other software
      </p>

      <p>Contact us for support or other purposes</p>

      <p>Use our email or share features</p>

      <p>Participate in events, contests, promotions, surveys, or game tests</p>

      <p>Participate in activities where you provide your information</p>

      <p>
        We may collect information such as your name, email address, phone
        number, photo, mailing address/zip code, payment or purchase
        information, age, gender, password, platform ID, software products
        played, survey data, geographic location, and the gaming system or
        platform you use, depending on the Service or your activity. We combine
        this information across all devices you use.
      </p>

      <p>—Game Information</p>

      <p>
        If you use the Services, we will automatically receive information
        related to your games. Game Information includes your platform ID or
        game service ID, game achievements, game scores and performance, IP
        address, MAC address or other device ID, other platform/device
        information, and other information and statistics related to your use of
        the Services. We collect Game Information even if you do not register
        for the Services. We may combine Game Information with other information
        we have about you. We may also use internal and third-party
        anti-cheating technology to detect and prevent cheating in our Services.
      </p>

      <p>—Platform, Game and Social Network Information</p>

      <p>
        If you access our Services using a third-party platform account (such as
        a game platform account, game network service account, or social network
        service account), we will collect information. If you access our
        Services in this way, the third-party platform will provide us with
        information about you. For example, based on your use of the third-party
        platform or your activities on such platform, we will receive your user
        name, your friends list, or account information required to provide
        services or purchase in-game items. The third-party platform may allow
        you to control the information provided to us. We are not responsible
        for the terms, policies, disclosures or actions of any third-party
        platform.
      </p>

      <p>—Cookies and Similar Technologies</p>

      <p>
        We may use cookies, web beacons, pixel tags, Flash cookies, internet log
        files, software development kits, and similar tracking technologies to
        improve and maintain the functionality of our Services; enhance security
        and fraud prevention; and provide you with targeted advertising. Our
        systems may not respond to “Do Not Track” requests or headers from some
        or all browsers. More information about our use of cookies and similar
        technologies and your options for managing cookies is set out in the
        section _Managing Your Account, Communications, and Data_. You can also
        use the Cookie Preferences tool (if available) or visit the Cookie
        Policy posted on the Services for more information.
      </p>

      <p>—Information Received from Third Parties</p>

      <p>
        We will receive information from third parties to update the information
        we collect about you. We may receive information from public databases,
        platform manufacturers, analytics providers, game developers, and other
        business partners and BANFAAN group of companies involved in providing the
        Services to you, including demographic information and information
        related to your interests. We may collect publicly available
        information, including from social media, to protect our users,
        employees, facilities, and services and to assist with investigations.
        We also receive information from other individuals who use our Services.
        This may include information about you if you are mentioned in a review
        on the Services or if an individual sends us a direct message.
      </p>

      <h2>When we share information</h2>
      <br />
      <p>
        We share your information with the following parties, as described
        below:
      </p>

      <p>Vendors who provide support and other services to us</p>

      <p>Members of the BANFAAN Group</p>

      <p>Advertising service providers and partners</p>

      <p>
        Other third parties (e.g., for collaborative product offerings and for
        legal and security purposes; in the event of a sale or transfer of
        business or assets; and for other purposes with your permission)
      </p>

      <p>
        Other users, such as when you participate in an open community or event,
        or post information on a leaderboard
      </p>

      <p>
        In the past 12 months, BANFAAN has sold and/or shared unique identifiers,
        IP addresses, and Internet/electronic activity and profile inferences
        with third-party advertising providers so that we can provide
        personalized advertising to you and others like you. We do not sell or
        share personal information about people under the age of 16 without
        their consent (or parental consent, depending on age).
      </p>

      <p>—Vendors</p>

      <p>
        We employ vendors to perform services on our behalf. These vendors
        provide us with business, professional, or technical support, help us
        operate our business and services, or manage activities related to our
        business and services.
      </p>

      <p>—Advertising</p>

      <p>
        We use BANFAAN and third-party (e.g., ad networks, data exchanges, traffic
        management service providers, social networks, and marketing analytics
        service providers) advertising to support our Services. Such providers
        use cookies and similar tracking technologies (see Cookies and Similar
        Technologies above) to collect information about your device and Service
        use. This information, and the information we share with them, enables
        us or our providers to recognize you or your device, serve ads to you or
        your device, and measure the effectiveness of such ads. This includes
        identifiers/contact information, internet/electronic activity, device
        and usage data, and profile inference information.
      </p>

      <p>
        We (and sometimes our providers) collect or share this information when
        you use our Services, click on a website or ad, or launch one of our
        games or other mobile applications. This information: (1) allows us to
        accurately and appropriately pay for advertising that is served on our
        behalf (e.g., an ad that directs you to purchase or download one of our
        games) and to generate revenue when you view ads on our Services; (2)
        helps prevent you from seeing the same ad repeatedly; (3) helps select
        and display targeted ads or other content on your device (e.g., on a
        website or social networking service you are visiting, or in a mobile
        application you are using) that may be of particular interest to you;
        (4) helps measure and analyze the effectiveness of our advertising, the
        popularity of our content, and the traffic to our Services; and (5)
        helps us improve our Services.
      </p>

      <p>
        You can learn more about managing how we and our providers use your
        information at Manage Your Account, Communications, and Data; and (where
        applicable to the Services) you can also use the Cookie Preferences tool
        (if available) or visit the Cookie Policy posted on the Services for
        more information.
      </p>

      <p>—Third Parties</p>

      <p>
        We share your information with third parties as described in this
        Privacy Policy, including:
      </p>

      <p>
        Partnerships: If we partner with a third party to provide a service or
        promotion, and such third party will receive your information for its
        own use, we will notify you at the time of collection and you will have
        the choice of whether to participate in the service or promotion
        provided.
      </p>

      <p>
        Legal and Security: We may share your information to protect the
        security of our services, servers, network systems, databases, users,
        and business; to investigate fraudulent activity, intellectual property
        infringement, harm to our rights, property or users, or other illegal
        activity or activity that may expose you or us to legal liability,
        including investigations requested by law enforcement or other
        government officials. We may also share your information with third
        parties when we reasonably believe disclosure is necessary to address
        potential or actual injury or damage to our rights, property,
        operations, users, or others who may be harmed or have suffered loss or
        damage; or when we believe it is necessary to protect our rights,
        conduct an investigation, or enforce our policies, terms, combat fraud,
        or comply with a judicial process, court order, or subpoena served on
        BANFAAN. We may also share your information when we reasonably believe it
        is necessary to conduct an investigation or enforce our policies, terms
        or services or the rights of third parties in connection with legal
        documents or contracts.
      </p>

      <p>
        Sales or Transfers of Business or Assets: We may sell or buy assets in
        the normal course of business. We may disclose information about you and
        transfer such information to other entities as part of a potential or
        actual acquisition or merger of BANFAAN or any of our assets. If we file a
        reorganization, bankruptcy or similar matter or defend against such a
        matter, such information may be considered an asset of ours and sold or
        transferred to third parties.
      </p>

      <p>
        Information Disclosed to You: We may share information that we disclose
        to you at the time we collect it.
      </p>

      <p>—Other Users</p>

      <p>
        If you participate in open communities, such as online game sessions and
        social networking services, we will automatically post certain
        information, such as your user name or ID and game statistics, in-game,
        on social networking services, on our services or on specialized gaming
        websites. If you participate in tournaments or other online gaming
        events, we must publicly post your information.
      </p>

      <p>
        If information based on your use of the services, such as your user name
        or ID, is an important part of the services we provide to you and
        others, we will publish gaming leaderboards and multiplayer match
        records that include such information. As with other gaming statistics
        services, your gaming activity, leaderboards, and multiplayer match
        information may be embedded within the Services or third-party web
        pages.
      </p>

      <p>
        Some third-party services also allow you to post information about your
        gaming activity to their websites so that you can share it with others.
        If you use such features, your actions on those websites and the
        information collected by those third-party services will be subject to
        the privacy policies and terms of those third-party services.
      </p>

      <p>
        We combine and publicly display information collected across services,
        including information collected on our Services, in our games, or in
        multiplayer game lobbies. For example, if you connect your gaming
        platform account with us, we may display your in-game achievements along
        with your account name.
      </p>

      <h2>Public Postings</h2>
      <br />
      <p>
        If you share personal information, post images or videos, or provide
        other content in a public forum (such as a message board, chat room,
        comment section, or profile page), that information may be viewed,
        collected, and used by others. If your user name or ID includes your
        name, your name will be publicly available on leaderboards and other
        locations as described in this Privacy Policy. Users of such public
        forums may be able to identify you, use that information to send you
        messages, or copy any images, videos, or content you share. You should
        not have any expectation that any such public forum will protect your
        privacy or keep your information confidential. Please do not share your
        personal information in public forums or under your username or ID. You
        are responsible for any information or content that you publicly post
        using our Services.
      </p>

      <h2>Data Rights</h2>
      <br />
      <p>
        Depending on your location, you may have certain rights with respect to
        your personal information, including the following:
      </p>

      <p>Request a copy of your personal information</p>

      <p>Request deletion of your personal information</p>

      <p>Request correction or amendment of your personal information</p>

      <p>
        Learn about the personal information we collect and/or process about
        you, the sources of your personal information, third parties with whom
        it is shared or sold, and the purposes for such activities
      </p>

      <p>Right to withdraw consent, if the processing relies on your consent</p>

      <p>
        Opt out of the sale or sharing of your personal information (including
        targeted advertising)
      </p>

      <p>Opt in/out of financial incentives</p>

      <p>Restrict use and disclosure of your sensitive personal information</p>

      <p>
        You may make a data rights request with respect to your personal
        information here. We will respond to such data requests within one
        month. We may take steps to verify your identity before responding to
        your request. If these rights apply to you, they may be limited in
        certain circumstances: for example, where we are required by law or have
        a compelling need to process your personal information, or where the
        personal information is protected by trade secret. If you have
        unresolved concerns, you also have the right to complain to a privacy
        authority (where appropriate). Privacy authorities are listed here.
        Alternatively, if you would like to make a data request or appeal a data
        request decision, please contact BANFAAN using the details provided in the
        Contact Us section.
      </p>

      <p>
        To opt out of the sale or sharing, click Do Not Sell or Share My
        Personal Information in the footer of our website (see here) and
        follow the instructions on that page. For more general opt-outs of
        online personalized advertising, see the opt-out options in the Manage
        Your Account, Communications, and Data section. We will not discriminate
        against you for exercising these rights.
      </p>

      <p>
        You can authorize someone (an authorized agent) to make a privacy
        request on your behalf. An authorized agent will need to demonstrate
        that you have authorized them to act on your behalf or must demonstrate
        that they have power of attorney under applicable probate law. We
        reserve the right to ask you directly to confirm whether such an agent
        has the authority to make such a request, or to request additional
        information to confirm such an agent identity.
      </p>

      <h2>Data Retention</h2>
      <br />
      <p>
        We will retain your information for as long as necessary to provide you
        with services, comply with our legal obligations, and/or exercise,
        defend or establish our rights.
      </p>

      <p>
        If your account is active, we will retain your information for as long
        as necessary to provide you with services or administer our services. If
        you would like to delete your account or request that we no longer use
        your personal information to provide you with services, please contact
        us as described in the section Managing Your Account, Communications and
        Data. If your account is inactive, we will retain your account for as
        long as we reasonably expect you to use our services again. After this
        period, we will delete the personal information, including your email
        address and login credentials, and you may no longer have access to your
        account. We may still retain some of your personal information in our
        files for a reasonable period of time to resolve disputes, enforce our
        terms and policies, administer our services, comply with technical and
        legal requirements and/or other limitations related to the security,
        integrity and operation of our services, after which we will take steps
        to delete your personal information or seal it.
      </p>

      <h2>Children Privacy</h2>
      <br />
      <p>
        In general, our services are intended for a general audience, and we do
        not knowingly collect personal information from children under the age
        of 13 (or older if applicable law provides for different protections).
        Some of our services may be intended for audiences of all ages,
        including children. For these services, we may restrict the collection
        of personal information from anyone in connection with the service,
        apply age restrictions on whether children are allowed to use the
        service, restrict the collection of personal information from children
        in connection with the service, or collect personal information from
        children with parental permission. If we learn that a child has provided
        personal information without parental permission, we will delete such
        information immediately. We recommend that parents instruct their
        children not to reveal their real name, address, or phone number without
        permission when using the Internet.
      </p>

      <h2>Data Security</h2>
      <br />
      <p>
        We follow generally accepted industry standards and maintain appropriate
        safeguards to help protect the security, integrity, and privacy of the
        information we collect about you. These safeguards are designed to
        protect the information under our control from accidental or unlawful
        destruction, loss, misuse, alteration, and unauthorized disclosure or
        access. However, no system is 100% secure, and we cannot guarantee that
        our safeguards are 100% secure.
      </p>

      <h2>International Transfers</h2>
      <br />
      <p>
        We and our suppliers and partners may process, transfer, and store
        information about you in the United States and other countries during
        the service, which may not have the same privacy laws as the country
        where you live. We use appropriate safeguards when transferring
        information.
      </p>

      <p>
        If your information is in another country, your information may be
        accessed by courts, law enforcement agencies and national security
        agencies in that country under the laws of that country. If you live in
        the UK, EU, EEA or Switzerland, we rely on Standard Contractual Clauses
        and/or other approved legal mechanisms to transfer personal information
        from the UK, EU, EEA or Switzerland to countries outside of those
        regions, as applicable. To request a copy of such Standard Contractual
        Clauses, as applicable, please make a data request as set out in the
        Data Rights section or Contact Us section.
      </p>

      <h2>Contact Us</h2>
      <br />
      <p>
        If you have any questions about this Privacy Policy, you may also
        contact us or our Data Protection Officer by postal mail to the address
        below. Please specify your location in your email. You also have the
        right to complain to a privacy authority. You may also contact us by
        email at shengzhengzhao@gmail.com.
      </p>
    </section>

    <!-- 更多部分... -->
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.privacy-policy {
  padding: 30px;
  font-family: Arial, sans-serif;
  max-width: 960px;
  margin: auto;
}

.privacy-policy h1,
.privacy-policy h2 {
  color: #333;
}

.privacy-policy p {
  line-height: 1.6;
  margin-bottom: 1em;
}

.privacy-policy ul {
  list-style-type: disc;
  margin-left: 20px;
}

.privacy-policy section {
  margin-bottom: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/views/pages/Privacy.vue